import React from 'react';

import { Employment } from './Employment/Employment';
import { Residency } from './Residency/Residency';
import { AssetWorth } from './AssetWorth/AssetWorth';

import './DashboardUserInfoRow.css';

export const DashboardUserInfoRow = ({ setZipCode, setUsState, user, tokenValue }) => {
  return (
    <div className="dashboard-user-info-row">
      <Employment user={user} tokenValue={tokenValue} />
      <Residency
        setZipCode={setZipCode}
        setUsState={setUsState}
        user={user}
        tokenValue={tokenValue}
      />
      <AssetWorth user={user} tokenValue={tokenValue} />
    </div>
  );
};
